import Vue from 'vue';
import ElementUI from 'element-ui';
import langTR from 'element-ui/lib/locale/lang/tr-TR';
import langEN from 'element-ui/lib/locale/lang/en';
import langRU from 'element-ui/lib/locale/lang/ru-RU';
import langZHTW from "element-ui/lib/locale/lang/zh-TW";
import langZHCH from "element-ui/lib/locale/lang/zh-CN";
import langDE from "element-ui/lib/locale/lang/de";
import elLocale from 'element-ui/lib/locale';
import i18n from './i18n';
import dayjs from 'dayjs';
Vue.use(ElementUI);
import CustomImageView from './components/ImageViewer';
import CustomInputTag from './components/Input-tag';
switch (i18n.locale) {
  case 'tr':
    elLocale.use(langTR);
    dayjs.locale('tr');
    break;
  case 'en':
    elLocale.use(langEN);
    dayjs.locale('en');
    break;
  case 'ru':
    elLocale.use(langRU);
    dayjs.locale('ru');
    break;
  case 'zh-tw':
    elLocale.use(langZHCH);
    dayjs.locale('zh-tw');
    break;
  case 'zh':
    elLocale.use(langZHTW);
    dayjs.locale('zh');
    break;
  case 'de':
    elLocale.use(langDE);
    dayjs.locale('de');
    break;

}
CustomImageView.install(Vue);
CustomInputTag.install(Vue);
import {
  Select,
  // ...
} from 'element-ui';

//   Vue.component(Button.name, Button)
